export default __webpack_public_path__ + "assets/images/bda65b83dac9f53abb2771ed9316acbc.svg";